module.exports = __webpack_public_path__ + "static/media/affliate.4fe84b1d.svg";